
/* ========== Enter Key Hard Block (no full search page) ========== */
(() => {
  if (window.__psBlockEnterArmed) return; window.__psBlockEnterArmed = true;

  const INPUT_SEL = 'input[name="q"], [data-predictive-search-input]';

  function blockForm(form){
    if (!form || form.__psBlocked) return;
    form.__psBlocked = true;

    const stopSubmit = (e) => { e.preventDefault(); e.stopImmediatePropagation(); return false; };
    form.addEventListener('submit', stopSubmit, true); // capture

    // Neutralise submit buttons
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(b => { b.type = 'button'; });

    // Block Enter bubbling via form (themes sometimes bind here)
    ['keydown','keypress','keyup'].forEach(ev => {
      form.addEventListener(ev, (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true); // capture
    });
  }

  function blockInput(input){
    if (!input || input.__psBlocked) return;
    input.__psBlocked = true;

    // Block Enter on the input itself
    ['keydown','keypress','keyup'].forEach(ev => {
      input.addEventListener(ev, (e) => {
        if (e.key === 'Enter') { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true); // capture
    });

    // Safari <input type="search"> special
    input.addEventListener('search', (e) => { e.preventDefault(); e.stopImmediatePropagation(); }, true);

    blockForm(input.closest('form'));
  }

  function armAll(scope=document){
    scope.querySelectorAll(INPUT_SEL).forEach(blockInput);
    scope.querySelectorAll('form').forEach(f => {
      if (f.querySelector(INPUT_SEL)) blockForm(f);
    });
  }

  // Initial run
  armAll();

  // Re-arm on DOM changes (drawers/predictive swaps)
  if (window.MutationObserver){
    const mo = new MutationObserver(() => armAll());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

// --- Ensure the "X" close button works ---
(() => {
  const INPUT_SEL = 'input[name="q"], [data-predictive-search-input]';
  const PANEL_SEL = '[data-predictive-search-panel], .predictive-search__content';
  const CLOSE_SEL = '[data-predictive-search-close], .predictive-search__close, .header-search button[type="button"]';

  function getPanel(){ return document.querySelector(PANEL_SEL); }
  function getInput(){ return document.querySelector(INPUT_SEL); }

  function closeSearch() {
  const input = document.querySelector('input[name="q"], [data-predictive-search-input]');

  // Clear input & notify theme listeners
  if (input) {
    input.value = '';
    try { input.dispatchEvent(new Event('input', { bubbles: true })); } catch {}
  }

  // Reset our custom keyword slot/state
  if (window.__psKwReset) window.__psKwReset();

  // Let the theme handle visibility; just drop its open class if it uses one
  document.body.classList.remove('predictive-search--open');
}

  function bindClose(){
    document.querySelectorAll(CLOSE_SEL).forEach(btn => {
      if (btn.__psCloseArmed) return;
      btn.__psCloseArmed = true;
      btn.addEventListener('click', e => {
        e.preventDefault();
        closeSearch();
      });
    });
  }

  // Initial bind + rebind on DOM redraws
  bindClose();
  if (window.MutationObserver){
    const mo = new MutationObserver(bindClose);
    mo.observe(document.documentElement, { childList:true, subtree:true });
  }
})();
